import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { change } from 'redux-form'
import notification from 'modules/app-core/notification-manager'
import * as actions from '../actions'
import {
  getLocationsListSelectorByPostalCode,
  getPendingRestorationSelector,
} from '../selectors'
import { LocationsDropdown } from '../components'

const VALID_POSTALCODE_LENGTH = 5

class LocationsContainer extends Component {
  static propTypes = {
    postalCode: PropTypes.string.isRequired,
    getLocations: PropTypes.func.isRequired,
    createNotification: PropTypes.func.isRequired,
    formName: PropTypes.string,
    fieldName: PropTypes.string,
    pendingRestoration: PropTypes.string,
  }

  static defaultProps = {
    list: [],
    formName: 'addEmployee',
    fieldName: 'County',
  }

  constructor(props) {
    super(props)
    this.previousPostalCode = props.postalCode
    this.previousPendingRestoration = props.pendingRestoration
  }

  componentWillMount() {
    if (
      this.props.postalCode &&
      this.props.postalCode.length === VALID_POSTALCODE_LENGTH
    ) {
      this.props.dispatch(this.props.getLocations(this.props.postalCode))
    }
    this.previousPostalCode = this.props.postalCode
  }

  // Reload county/state list if postal code changes.
  componentWillReceiveProps(nextProps) {
    // Load locations if postal code changes or becomes available
    if (
      nextProps.postalCode &&
      nextProps.postalCode.length === VALID_POSTALCODE_LENGTH &&
      (this.previousPostalCode !== nextProps.postalCode || !this.props.list)
    ) {
      this.props.dispatch(this.props.getLocations(nextProps.postalCode))
      this.previousPostalCode = nextProps.postalCode
    }

    // Handle pending restoration
    if (
      nextProps.pendingRestoration &&
      nextProps.pendingRestoration !== this.previousPendingRestoration &&
      nextProps.list &&
      nextProps.list.length > 0
    ) {
      this.handlePendingRestoration(
        nextProps.pendingRestoration,
        nextProps.list
      )
      this.previousPendingRestoration = nextProps.pendingRestoration
    }
  }

  handlePendingRestoration = (countyToRestore, availableLocations) => {
    // Check if the county to restore is available in the new locations
    const isAvailable = availableLocations.some(
      (location) => location.County === countyToRestore
    )

    if (isAvailable) {
      // Restore the selection
      this.props.dispatch(
        change(this.props.formName, this.props.fieldName, countyToRestore)
      )
    } else {
      // Try to find a similar county
      const similarCounty = this.findSimilarCounty(
        countyToRestore,
        availableLocations
      )
      if (similarCounty) {
        this.props.dispatch(
          change(
            this.props.formName,
            this.props.fieldName,
            similarCounty.County
          )
        )
        this.props.createNotification({
          type: 'info',
          message: `County updated from "${countyToRestore}" to "${similarCounty.County}" due to benefit year change`,
        })
      } else {
        // Clear the selection and notify user
        this.props.dispatch(
          change(this.props.formName, this.props.fieldName, '')
        )
        this.props.createNotification({
          type: 'warning',
          message: `County "${countyToRestore}" is not available for this benefit year. Please select a new county.`,
        })
      }
    }

    // Clear the pending restoration after processing
    this.props.clearPendingRestoration(this.props.postalCode)
  }

  findSimilarCounty = (targetCounty, availableLocations) => {
    if (!targetCounty || !availableLocations) return null

    // Try case-insensitive exact match
    let match = availableLocations.find(
      (location) => location.County.toLowerCase() === targetCounty.toLowerCase()
    )
    if (match) return match

    // Try partial match
    match = availableLocations.find(
      (location) =>
        location.County.toLowerCase().includes(targetCounty.toLowerCase()) ||
        targetCounty.toLowerCase().includes(location.County.toLowerCase())
    )
    if (match) return match

    return null
  }

  render() {
    return <LocationsDropdown {...this.props} />
  }
}

const mapStateToProps = (state, { postalCode }) => ({
  list: getLocationsListSelectorByPostalCode(postalCode, state),
  pendingRestoration: getPendingRestorationSelector(postalCode, state),
})

const mapDispatchToProps = (dispatch) => ({
  ...actions,
  ...notification.actions,
  dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)(LocationsContainer)
